import * as React from "react"

import { useNavigationContext } from "shared/components/NavigationContext"
import useEditor from "shared/hooks/useEditor"
import { CatalogNavigation } from "shared/hubrise/catalogNavigation"
import { LastVisits } from "shared/hubrise/catalogNavigation/LastVisits"

type UseCatalogNavigation = {
  catalogNavigation: CatalogNavigation
  visit: (...args: Parameters<LastVisits["visit"]>) => void
  variantRef: string | null
}

const useCatalogNavigation = (): UseCatalogNavigation => {
  const { getOrCreateCatalogNavigation, visit: originalVisit } = useNavigationContext()
  const { catalog, editor } = useEditor()

  const variantRef = new URLSearchParams(location.search).get("variant_ref")

  const visit = React.useCallback<UseCatalogNavigation["visit"]>(
    (...visitArgs) => {
      originalVisit(editor, ...visitArgs)
    },
    [editor, originalVisit],
  )

  return {
    catalogNavigation: getOrCreateCatalogNavigation(catalog),
    variantRef,
    visit,
  }
}

export default useCatalogNavigation
